export default "__VITE_ASSET__COTA_6vC__"